import { useEffect, useState, type ReactNode } from "react";
import { resolveWelcome } from "@features/welcome/welcome-decision";
import { markWelcomeSeen } from "@features/welcome/welcome-storage";
import { WelcomeScreen } from "@features/welcome/components/welcome-screen";

/**
 * Native-only first-run intro. The decision is latched once (see
 * `resolveWelcome`) and never recomputed from live auth state, so the overlay
 * cannot flash or resurrect after a transient sign-in/out.
 */
export function WelcomeGate({ children }: { children: ReactNode }) {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    let active = true;
    void resolveWelcome().then((show) => {
      if (active && show) setShowWelcome(true);
    });
    return () => {
      active = false;
    };
  }, []);

  const handleDone = () => {
    void markWelcomeSeen();
    setShowWelcome(false);
  };

  return (
    <>
      {children}
      {showWelcome ? <WelcomeScreen onDone={handleDone} /> : null}
    </>
  );
}
